import dynamic from 'next/dynamic';
import { COMPONENT_PREFIX } from '../constants';

const PRODUCT_PRICE_BUTTON_VARIANT = `${COMPONENT_PREFIX}productprice-button`;

export default {
  [PRODUCT_PRICE_BUTTON_VARIANT]: {
    getSettings: componentSettings => componentSettings,
    VariantComponent: dynamic(
      () =>
        import(
          /* webpackChunkName: "kelShopwareProductPriceButton" */ '../components/ProductPrice/ProductPriceButton'
        )
    )
  }
};
